<div class="folder-dialog-container" data-cy="save-lib-lec-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="save-lib-lec-header-section">
      <div class="section-header-title" data-cy="save-lib-lec-title-text">
        Save in  Library / Lecture
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="save-lib-lec-content-section">
      <div class="row" data-cy="save-lib-lec-rows-container">
        <div class="column" data-cy="save-lib-lec-library-column">
          <div style="height: 460px; margin-left: 5px;" data-cy="save-lib-lec-library-container">
            <div class="section-header-title" style="text-align: center; border-bottom-style: inset; margin-left: 10px; margin-right: 10px;" data-cy="save-lib-lec-library-title">
              Library
            </div>
            @if (libraryTreeData.length > 0) {
              <tdo-tree #libraryTree
                (itemSelected)="onLibraryTreeItemSelected($event)"
                [dataSource]="libraryTreeData"
                [template]="treeItem" data-cy="save-lib-lec-library-tree">
                <ng-template #treeItem let-item>
                  <div (contextmenu)="onLibraryTreeContext($event, item); false"
                    style="display: flex; cursor: pointer; font-size: 14px;"
                    [ngClass]="{'selected-itemRow': isItemSelected(item)}" data-cy="save-lib-lec-library-item">
                    @if (item.matIconOverride) {
                      <lucide-icon name="trash-2" [size]="20" style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="save-lib-lec-library-delete-icon"></lucide-icon>
                    }
                    @if (!item.matIconOverride) {
                      @if (!item.isExpanded) {
                        <div style="flex-basis: 36px;" data-cy="save-lib-lec-library-closed-folder">
                          <img style="width: 80%; margin-top: 4px; margin-right: 6px;"
                            src="../../../../assets/Images/image-organizer/icons8-folder-closed-20.svg" alt="closed folder icon">
                          </div>
                        }
                        @if (item.isExpanded) {
                          <div style="flex-basis: 36px;" data-cy="save-lib-lec-library-open-folder">
                            <img style="width: 80%; margin-right: 6px; margin-top: 5px;"
                              src="../../../../assets/Images/image-organizer/icons8-folder-opened-20.svg" alt="opened folder icon">
                            </div>
                          }
                        }
                        <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                        [ngClass]="{'selected-item': isItemSelected(item)}" data-cy="save-lib-lec-library-item-name">{{item.name}}</div>
                      </div>
                    </ng-template>
                  </tdo-tree>
                }
              </div>
            </div>
            <div class="column" data-cy="save-lib-lec-lecture-column">
              <div style="height: 460px; margin-left: 5px;" data-cy="save-lib-lec-lecture-container">
                <div class="section-header-title" style="text-align: center; border-bottom-style: inset; margin-left: 10px; margin-right: 10px;" data-cy="save-lib-lec-lecture-title">
                  Lecture
                </div>
                @if (lectureTreeData.length > 0) {
                  <tdo-tree #libraryTree
                    (itemSelected)="onLectureTreeItemSelected($event)"
                    [dataSource]="lectureTreeData"
                    [template]="treeItem2" data-cy="save-lib-lec-lecture-tree">
                    <ng-template #treeItem2 let-item>
                      <div (contextmenu)="onLibraryTreeContext($event, item); false"
                        style="display: flex; cursor: pointer; font-size: 14px;"
                        [ngClass]="{'selected-itemRow': isLectureItemSelected(item)}" data-cy="save-lib-lec-lecture-item">
                        @if (item.matIconOverride) {
                          <lucide-icon name="trash-2" [size]="20" style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="save-lib-lec-lecture-delete-icon"></lucide-icon>
                        }
                        @if (!item.matIconOverride) {
                          @if (!item.isExpanded) {
                            <div style="flex-basis: 36px;" data-cy="save-lib-lec-lecture-closed-folder">
                              <img style="width: 80%; margin-top: 4px; margin-right: 6px;"
                                src="../../../../assets/Images/image-organizer/icons8-folder-closed-20.svg" alt="closed folder icon">
                              </div>
                            }
                            @if (item.isExpanded) {
                              <div style="flex-basis: 36px;" data-cy="save-lib-lec-lecture-open-folder">
                                <img style="width: 80%; margin-right: 6px; margin-top: 5px;"
                                  src="../../../../assets/Images/image-organizer/icons8-folder-opened-20.svg" alt="opened folder icon">
                                </div>
                              }
                            }
                            <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                            [ngClass]="{'selected-item': isLectureItemSelected(item)}" data-cy="save-lib-lec-lecture-item-name">{{item.name}}</div>
                          </div>
                        </ng-template>
                      </tdo-tree>
                    }
                  </div>
                </div>
              </div>
            </div>
            <!--  FOOTER-->
            <div class="section-footer" style="flex-basis: 60px;" data-cy="save-lib-lec-footer-section">
              <div style="flex: 1; margin-right: 6px;"></div>
              <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="save-lib-lec-cancel-button">Cancel</button>
              <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="save-lib-lec-ok-button">Ok</button>
            </div>
          </div>
        </div>
        <ng-template #lectureContextMenu let-data>
          @if (!isTrashFolder(data)) {
            <section class="image-context-menu" data-cy="save-lib-lec-context-menu">
              <div (click)="addDocumentFolder(data)" class="item" data-cy="save-lib-lec-add-folder-item">Add folder</div>
            </section>
          }
        </ng-template>
